import React, { FC } from "react";

import {
  ParticipantStatus,
  PaymentLineDetailsWithResaleDetails,
  PaymentLineStatuses,
  SortDirection,
  useListPaymentLinesQuery,
} from "@api/graphql";
import { useIsAuthUserAllowed, useIsAuthorisedUser } from "@components/permission_control/ProtectedComponent";
import { Royalties } from "@components/royalties/Royalties";
import { InternalRoles } from "@roles";
import { FilterByTyped, SortByTyped } from "@util/index";

import styles from "./UpcomingRoyalties.module.scss";

export const UpcomingRoyalties: FC<{ displayBanner?: boolean; payeeId?: number }> = ({ displayBanner, payeeId }) => {
  const isInternalUser = useIsAuthUserAllowed(InternalRoles);
  const sort_by: SortByTyped<PaymentLineDetailsWithResaleDetails> = {
    field: "id",
    direction: SortDirection.ASCENDING,
  };

  const filter_by: FilterByTyped<PaymentLineDetailsWithResaleDetails>[] = [
    {
      field: "status",
      in: [
        PaymentLineStatuses.PROVISIONAL,
        PaymentLineStatuses.READY_TO_PAY,
        PaymentLineStatuses.READY_TO_REQUEST,
        PaymentLineStatuses.SENT_TO_FINANCE,
      ],
    },
  ];

  // payee_id filter is only allowed for VA/MS/Data; royalty recipients are scoped by the API to their own participant
  if (isInternalUser && payeeId) {
    filter_by.push({ field: "payee_id", eq: payeeId.toString() });
  }

  const isPendingParticipant = useIsAuthorisedUser({
    requiredParticipantStatus: ParticipantStatus.PENDING_APPROVAL,
  });
  return (
    <Royalties
      queryFunction={useListPaymentLinesQuery}
      getQueryVariables={(page) => ({
        // if current user attached to a participant is pending approval, then don't show any data
        input: { page, limit: isPendingParticipant ? 0 : 10, filter_by, sort_by },
      })}
      updateQueryVariablesWithFilter={({ input: { page, limit, filter_by, sort_by } }, new_filter_by) => ({
        input: {
          page,
          limit,
          filter_by: filter_by.concat(new_filter_by ? new_filter_by : []),
          sort_by,
        },
      })}
      getPaymentLinesFromQueryData={(data) => data.listPaymentLines.results}
      getPaginatedOutputFromQueryData={(data) => data.listPaymentLines}
      sourcePage={"UpcomingRoyalties"}
      customTableStyleClassName={styles["customized-column-width"]}
      displayBanner={displayBanner}
    />
  );
};
